<template>
  <router-view />
</template>

<script>
//json
import jsonMenuList from "@/assets/json/Menu.js";
import jsonTableGroupList from "@/assets/json/TableGroup.js";
import jsonTableList from "@/assets/json/Table.js";
import jsonTableOrderList from "@/assets/json/TableOrder.js";
import jsonReceiptList from "@/assets/json/ReceiptList.js";
import jsonSalesList from "@/assets/json/SalesList.js";

import jsonGroupList from "@/assets/json/GroupMenu.js";
import jsonPaymentList from "@/assets/json/PaymentList.js";
import jsonDescList from "@/assets/json/DescList.js";
import jsonTbMstItem from "@/assets/json/TbMstItem.js";
import jsonTbMstOpt from "@/assets/json/TbMstOpt.js";
import jsonCouponList from "@/assets/json/Coupon.js";
import jsonHoldList from "@/assets/json/OrderHold";

import jsonCouponGroupList from "@/assets/json/CouponGroup.js";
import jsonCouponDetailList from "@/assets/json/CouponDetail.js";

import jsonSetMenuOptionList from "@/assets/json/SetMenuOption.js";
import jsonSetMenuItemList from "@/assets/json/SetMenuItem.js";
export default {
  data() {
    return {
      tableGroupList: jsonTableGroupList.data.tableGroupList,
      tableList: jsonTableList.data.tableList,
      orderList: jsonTableOrderList.data.orderList,
      menuList: jsonMenuList.data.menuList,

      groupList: jsonGroupList.data.groupList,
      paymentList: jsonPaymentList.data.paymentList,
      descList: jsonDescList.data.descList,
      mstOptionList: jsonTbMstOpt.data.mstOptionList,
      mstItemList: jsonTbMstItem.data.mstItemList,
      couponList: jsonCouponList.data.couponList,
      receiptList: jsonReceiptList.data.receiptList,
      salesList: jsonSalesList.data.salesList,
      holdList: jsonHoldList.data.holdList,

      couponGroupList: jsonCouponGroupList.data.couponGroupList,
      couponDetailList: jsonCouponDetailList.data.couponDetailList,

      setMenuOptionList: jsonSetMenuOptionList.data.setMenuOptionList,
      setMenuItemList : jsonSetMenuItemList.data.setMenuItemList,
    };
  },
  mounted() {
    this.$store.dispatch("setTableGroupList", this.tableGroupList);
    this.$store.dispatch("setTableList", this.tableList);
    this.$store.dispatch("setOrderList", this.orderList);
    this.$store.dispatch("setMenuList", this.menuList);

    this.$store.dispatch("setGroupList", this.groupList);
    this.$store.dispatch("setPaymentList", this.paymentList);
    this.$store.dispatch("setDescList", this.descList);
    this.$store.dispatch("setMstOptionList", this.mstOptionList);
    this.$store.dispatch("setMstItemList", this.mstItemList);
    this.$store.dispatch("setCouponList", this.couponList);

    this.$store.dispatch("setReceiptList", this.receiptList);
    this.$store.dispatch("setSalesList", this.salesList);
    this.$store.dispatch("setHoldList", this.holdList);

    this.$store.dispatch("setCouponGroupList", this.couponGroupList);
    this.$store.dispatch("setCouponDetailList", this.couponDetailList);

    this.$store.dispatch("setSetMenuOptionList", this.setMenuOptionList);
    this.$store.dispatch("setSetMenuItemList", this.setMenuItemList);
  },
};
</script>

<style>
@media (-webkit-device-pixel-ratio: 1.25) {
  html {
    zoom: 0.8 !important;
  }
}

body {
  position: relative;
  width: 1024px;
  height: 768px;
}
html {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: #333;
  font-family: "SpoqaHanSansNeo";
  font-size: 14px;
  letter-spacing: -0.1px;
  user-select: none;
}

#app {
  height: 768px;
}
</style>
